import { useState } from 'react'
import { useIntl } from 'react-intl'



import RespiratorySyndromsGraph from '../component/RespiratorySyndromsGraph'
import AnomalyDetectionGraph from '../component/AnomalyDetectionGraph'
import PerceptionsOnVaccination from '../component/PerceptionsOnVaccination'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}


// const generateRandomData = (serieId, numWeeks) => {
//   return Array.from({length: numWeeks}, (_, week) => ({
//     x: week + 1,
//     y: Math.floor(Math.random() * 20) + 5, // Random value between 5 and 25
//   }))
// }


const RespiratorySyndroms = () => {
  const intl = useIntl()
  const [showSeasonRespModal, setShowSeasonRespModal] = useState(false);
  const [showSeasonAmlyModal, setShowSeasonAmlyModal] = useState(false);
  const [showPercptVacModal, setShowPercptVacModalModal] = useState(false);
  const [selectedVirus, setSelectedVirus] = useState<'Influenza' | 'Covid' | 'RSV'>('Influenza')

  return (
    <>
      <div className='  p-0 w-100 justify-content-md-center container-fluid'>
        <div className=' mb-5'>
          <RespiratorySyndromsGraph season={mainSeason} onClick={() => setShowSeasonRespModal(true)} />
        </div>
        <div className='mb-5'>
          <AnomalyDetectionGraph season={mainSeason} onClick={() => setShowSeasonAmlyModal(true)} />
        </div>
        <div className='mb-5'>
          <PerceptionsOnVaccination
            season={mainSeason}
            onClick={() => setShowPercptVacModalModal(true)}
            selectedVirus={selectedVirus}
            onVirusChange={setSelectedVirus}
          />
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonRespModal}
        onHide={() => setShowSeasonRespModal(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title className='bold'>
            <h2 className='text-primary  p-2 bold'>
              Respiratory syndromes in social media 2023-2024 (France){' '}
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                    <p>
                      Based on extraction of messages featuring respiratory symptoms (extraction
                      performed by Brandwatch®), with 50 key medical concepts related to respiratory
                      symptoms (based on the MedDRA medical dictionary and enriched by social network
                      specific patient vocabulary). Data was modeled as a multidimensional time
                      series: each datapoint is composed of the number of posts and users containing
                      each concept on a given day. Data updated weekly. Source: KapCode
                    </p>
                  </Tooltip>
                }
              >
                <img
                  //className='mb-1'
                  style={{ width: '12px' }}
                  alt='logo'
                  src={toAbsoluteUrl('/media/logos/ii.svg')}
                />
              </OverlayTrigger>
            </h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <RespiratorySyndromsGraph season={modalSeason} onClick={() => setShowSeasonRespModal(true)} />
        </Modal.Body>
      </Modal>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonAmlyModal}
        onHide={() => setShowSeasonAmlyModal(false)}
        centered
      >
        <Modal.Header className='py-3' closeButton>
          <Modal.Title>
            <h2 className='text-primary p-2 bold'>
              {' '}
              Anomaly detection in the volume of messages reporting respiratory syndromes 2023-2024 (France){' '}
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                    <p>
                      Anomaly detection: the anomaly is based on the mean squared root between
                      predicted values and true ones. Using the validation data, an unsupervised
                      isolation forest model was used to measure from these mean squared root errors
                      to which extent a point can be considered an “outlier”. Three anomaly levels
                      were determined : 99th , 95th and 90th percentile of most anomalous points.
                      Each week, data from the year before is used to make a forecast and compared
                      to actual data, the mean squared error is calculated and used to compare to
                      the thresholds previously defined. Source: KapCode{' '}
                    </p>
                  </Tooltip>
                }
              >
                <img
                  //className='mb-1'
                  style={{ width: '12px' }}
                  alt='logo'
                  src={toAbsoluteUrl('/media/logos/ii.svg')}
                />
              </OverlayTrigger>
            </h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <AnomalyDetectionGraph season={modalSeason} onClick={() => setShowSeasonAmlyModal(true)} />
        </Modal.Body>
      </Modal>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showPercptVacModal}
        onHide={() => setShowPercptVacModalModal(false)}
        centered
      >
        <Modal.Header className='py-3' closeButton>
          <Modal.Title>
            <h2 className='text-primary p-2  bold'>
              Perceptions on vaccination campaigns Winter 2023-2024 (France){' '}
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                    <p>
                      Weekly evolution of acceptation of vaccination campaigns for Influenza,
                      SARS-Cov2 and RSV based on social media analysis: For each message extracted, a
                      pre-trained sentiment model is applied, with an output that can be positive,
                      negative or neutral. A message is attributed the “positive” label if it
                      characterizes the policies as efficient or shows that they are accepted by the
                      writer of the message. On the other hand, a message is labeled “negative” when
                      the message describes these policies as inefficient or having a significative
                      negative impact on the person’s quality of life, or generally if the person
                      doesn’t adhere to the policies. Source: KapCode
                    </p>
                  </Tooltip>
                }
              >
                <img
                  //className='mb-1'
                  style={{ width: '12px' }}
                  alt='logo'
                  src={toAbsoluteUrl('/media/logos/ii.svg')}
                />
              </OverlayTrigger>
            </h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <PerceptionsOnVaccination
            season={modalSeason}
            onClick={() => setShowPercptVacModalModal(true)}
            selectedVirus={selectedVirus}
            onVirusChange={setSelectedVirus}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export { RespiratorySyndroms }
